module.exports = __webpack_public_path__ + "assets/img/ludimos-dashboard.a194f3e7.png";